// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"65":"8389021cd3e4886a","139":"91b7aa66edda88dc","630":"7ef0c8253c2a9ac7","646":"0e636499d87f8634"}[chunkId] + ".js";
};